var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightRoundedBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0379 12.5379C20.404 12.1718 20.404 11.5782 20.0379 11.2121C19.6718 10.846 19.0782 10.846 18.7121 11.2121L13.125 16.7992L11.2879 14.9621C10.9218 14.596 10.3282 14.596 9.96209 14.9621C9.59597 15.3282 9.59597 15.9218 9.96209 16.2879L12.4621 18.7879C12.8282 19.154 13.4218 19.154 13.7879 18.7879L20.0379 12.5379Z",
    fill: "#1373E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.5625C7.57867 1.5625 1.5625 7.57867 1.5625 15C1.5625 22.4213 7.57867 28.4375 15 28.4375C22.4213 28.4375 28.4375 22.4213 28.4375 15C28.4375 7.57867 22.4213 1.5625 15 1.5625ZM3.4375 15C3.4375 8.61421 8.61421 3.4375 15 3.4375C21.3858 3.4375 26.5625 8.61421 26.5625 15C26.5625 21.3858 21.3858 26.5625 15 26.5625C8.61421 26.5625 3.4375 21.3858 3.4375 15Z",
    fill: "#1373E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0379 12.5379C20.404 12.1718 20.404 11.5782 20.0379 11.2121C19.6718 10.846 19.0782 10.846 18.7121 11.2121L13.125 16.7992L11.2879 14.9621C10.9218 14.596 10.3282 14.596 9.96209 14.9621C9.59597 15.3282 9.59597 15.9218 9.96209 16.2879L12.4621 18.7879C12.8282 19.154 13.4218 19.154 13.7879 18.7879L20.0379 12.5379Z",
    stroke: "#1373E7",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.5625C7.57867 1.5625 1.5625 7.57867 1.5625 15C1.5625 22.4213 7.57867 28.4375 15 28.4375C22.4213 28.4375 28.4375 22.4213 28.4375 15C28.4375 7.57867 22.4213 1.5625 15 1.5625ZM3.4375 15C3.4375 8.61421 8.61421 3.4375 15 3.4375C21.3858 3.4375 26.5625 8.61421 26.5625 15C26.5625 21.3858 21.3858 26.5625 15 26.5625C8.61421 26.5625 3.4375 21.3858 3.4375 15Z",
    stroke: "#1373E7",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightRoundedBox);
export default __webpack_public_path__ + "static/media/right_rounded_box.f09ddd76db2e681c64786179da18a30e.svg";
export { ForwardRef as ReactComponent };